<template>
    <div class="p-5">
        <h2>{{ $t("vacations.add") }}</h2>

        <div class="row w-50">
            <div>
                <div class="col-12">
                    <label for="driver" class="mt-2">{{ $t("transportations.chooseDriver") }}</label>
                </div>
                <div class="col-12">
                    <select v-model="formData.driver" class="form-control form-select" id="driver" name="driver"
                        size="1" required>
                        <option v-for="driver in drivers" v-key="driver.id" :value="driver.id">
                            {{ driver.first_name }} {{ driver.last_name }} ({{ driver.username }})
                        </option>
                    </select>
                </div>
            </div>

            <div class="col-12">
                <label for="vacation_from" class="mt-2">{{ $t("vacations.from") }}</label>
            </div>
            <div class="col-12">
                <input v-model="formData.vacation_from" type="datetime-local" class="form-control" id="vacation_from"
                    name="vacation_from" required>
            </div>
            <div class="col-12">
                <label for="vacation_to" class="mt-2">{{ $t("vacations.to") }}</label>
            </div>
            <div class="col-12">
                <input v-model="formData.vacation_to" type="datetime-local" class="form-control" id="vacation_to"
                    name="vacation_to" placeholder="" required>
            </div>
            <div class="col-12">
                <button @click="submitForm" type="submit" class="mt-4 btn btn-primary w-100 form-submit">{{
                    $t("utils.add") }}</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            warehouses: [],
            drivers: [],
            formData: {
                driver: null,
                vacation_from: null,
                vacation_to: null
            }
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get("/drivers").then((response) => {
                this.drivers = response.data.items;
            });
        },
        submitForm() {
            this.$store.getters.api.post("/user_vacation/add", this.formData)
                .then((response) => {
                    this.formData = response.data;
                    this.$router.push({ "name": "UserVacations" });
                });
        }
    },

}
</script>
<style scoped lang="scss"></style>